// benefits-slider.js
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

import Flickity from "flickity";

class BenefitsSlider {
    constructor(elementOrSelector) {
        // Element akzeptieren oder via Selector finden
        this.root = typeof elementOrSelector === "string"
            ? document.querySelector(elementOrSelector)
            : elementOrSelector;

        if (!this.root) {
            console.warn("BenefitsSlider: root element not found.", elementOrSelector);
            return;
        }

        // Carousel-Element finden
        this.carouselEl = this.root.querySelector(".carousel");
        if (!this.carouselEl) {
            console.warn("BenefitsSlider: .carousel not found within root.", this.root);
            return;
        }

        // Pfeile
        this.nextArrow = this.root.querySelector(".js-slider-button-next");
        this.prevArrow = this.root.querySelector(".js-slider-button-prev");

        if (!this.nextArrow || !this.prevArrow) {
            console.warn("BenefitsSlider: missing prev/next arrow buttons.", this.root);
        }

        // Flickity: KEIN wrapAround
        this.flkty = new Flickity(this.carouselEl, {
            adaptiveHeight: false,     // du nutzt keinen Equalizer, also kann das hier ruhig false bleiben
            cellAlign: "left",
            draggable: true,
            pageDots: false,
            prevNextButtons: false,
            initialIndex: 0,
            wrapAround: false
        });

        this.slideCount = 0;

        // Flickity ready
        this.flkty.on("ready", () => {
            this.slideCount = this.flkty.slides.length;

            this.setCurrentSlide(this.flkty.selectedIndex);
            this.updatePassedSlides(this.flkty.selectedIndex);

            ScrollTrigger.refresh(); // wichtig, da Höhe sich nach init ändert
        });

        this.flkty.on("settle", () => {
            ScrollTrigger.refresh();
        });

        this.flkty.on("change", (index) => this.onSlideChange(index));

        // Button-Events
        this.prevArrow?.addEventListener("click", (e) => {
            e.preventDefault();
            this.flkty.previous();
        });

        this.nextArrow?.addEventListener("click", (e) => {
            e.preventDefault();
            this.flkty.next();
        });

        // Refresh nach vollständigem Laden
        const init = () => this.refresh();
        if (document.readyState === "complete") init();
        else window.addEventListener("load", init);
    }

    onSlideChange(index) {
        this.setCurrentSlide(index);
        this.updatePassedSlides(index);
    }

    /**
     * Slides links vom aktiven Slide ausblenden
     */
    updatePassedSlides(activeIndex) {
        if (!this.flkty?.cells) return;

        this.flkty.cells.forEach((cell, i) => {
            const el = cell.element;
            if (i < activeIndex) {
                el.classList.add("is-passed");
            } else {
                el.classList.remove("is-passed");
            }
        });
    }

    /**
     * Prev/Next-Button-Status setzen
     */
    setCurrentSlide(index) {
        if (!this.prevArrow || !this.nextArrow) return;

        // Prev disabled?
        if (index === 0) {
            this.prevArrow.classList.add("is-disabled");
        } else {
            this.prevArrow.classList.remove("is-disabled");
        }

        // Next disabled?
        if (index === this.slideCount - 1) {
            this.nextArrow.classList.add("is-disabled");
        } else {
            this.nextArrow.classList.remove("is-disabled");
        }
    }

    /**
     * Refresh: Flickity neu berechnen + is-passed & Buttons neu setzen
     */
    refresh() {
        if (!this.flkty) return;

        this.flkty.reloadCells();
        this.flkty.resize();
        this.flkty.reposition();

        this.slideCount = this.flkty.slides.length;

        this.setCurrentSlide(this.flkty.selectedIndex);
        this.updatePassedSlides(this.flkty.selectedIndex);

        ScrollTrigger.refresh();
    }

    static mountAll(selector = ".benefits.teaser-slider.js-teaser-slider") {
        document.querySelectorAll(selector).forEach((el) => new BenefitsSlider(el));
    }
}

export default BenefitsSlider;
